import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PARENT_ROUTE_MAP = {
  "/dashboard": "/parent-portal/dashboard",
  "/assessment": "/parent-portal/assessment",
  "/reports": "/parent-portal/reports",
  "/career-skills": "/parent-portal/career-skills",
  "/council": "/parent-portal/council",
  "/counseling": "/parent-portal/counseling",
  "/milestone": "/parent-portal/milestone",
  "/chatbot": "/parent-portal/chatbot",
  "/chatbuddy": "/parent-portal/chatbuddy",
  "/announcement": "/parent-portal/announcement",
  "/feedback": "/parent-portal/feedback",
  "/how-it-works": "/parent-portal/how-it-works",
  "/dna": "/parent-portal/dna",
  "/profile": "/parent-portal/profile",
};

const withAuth = (Component, allowedRoles= ["Admin", "School", "Student"]) => {
  return (props) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();

    if (!user) {
      return <Navigate to="/login" />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
      return <Navigate to="/" />;
    }

    if (user.role === "Parent" && PARENT_ROUTE_MAP[location.pathname]) {
      return <Navigate to={PARENT_ROUTE_MAP[location.pathname]} replace />;
    }

    return <Component {...props} />;
  };
};

export default withAuth;
